import { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { addTranslation } from "@/utils/i18n";
import { zodUnsafeValidate } from "@/utils/zod";
import { consentStore, initConsent, openCookieSettings } from "./consent";
import { CookieConsent } from "./types";

const CookieConsentRoot = lazy(() =>
  import("./components/CookieConsentRoot").then((m) => ({
    default: m.CookieConsentRoot,
  })),
);

/**
 * Замена CookiePro (OneTrust). Вызывается первым в createLayout(): до решения
 * аналитика запрещена (см. consentStore).
 */
export const createCookieConsent = () => {
  if (window.cookieConsentConfig === undefined) {
    return;
  }

  const config = zodUnsafeValidate(
    CookieConsent.ConfigSchema,
    window.cookieConsentConfig,
  );

  initConsent(config);

  addTranslation(config.translation);

  // футер и любые другие точки входа
  document.addEventListener("click", (event) => {
    const trigger =
      event.target instanceof Element
        ? event.target.closest("[data-cookie-settings]")
        : null;

    if (trigger !== null) {
      event.preventDefault();
      openCookieSettings();
    }
  });

  let mounted = false;

  const mount = () => {
    if (mounted === true) {
      return;
    }

    mounted = true;

    const container = document.createElement("div");

    document.body.appendChild(container);

    createRoot(container).render(
      <Suspense>
        <CookieConsentRoot />
      </Suspense>,
    );
  };

  const { decided, settings } = consentStore.getState();

  // UI грузим лениво: только если нужен баннер или пользователь открыл настройки
  if (decided === false || settings === true) {
    mount();
  } else {
    const unsubscribe = consentStore.subscribe((state) => {
      if (state.settings === true) {
        unsubscribe();
        mount();
      }
    });
  }
};
